import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowLeft = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.7071 4.29289C11.0976 4.68342 11.0976 5.31658 10.7071 5.70711L5.41422 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H5.17422L9.75926 18.3492C10.1187 18.7685 10.0701 19.3998 9.65079 19.7593C9.23147 20.1187 8.60017 20.0701 8.24075 19.6508L2.24075 12.6508C1.90069 12.2541 1.92341 11.6624 2.2929 11.2929L9.2929 4.29289C9.68342 3.90237 10.3166 3.90237 10.7071 4.29289Z", fill: color }));
};
export default factorySvgIcon(SvgArrowLeft);
//# sourceMappingURL=SvgBack.js.map